import { render, staticRenderFns } from "./carreiras.vue?vue&type=template&id=c1fa5666&"
import script from "./carreiras.vue?vue&type=script&lang=js&"
export * from "./carreiras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CursosBannerIndex: require('/opt/buildhome/repo/components/Cursos/BannerIndex.vue').default,CursosComoFuncionam: require('/opt/buildhome/repo/components/Cursos/ComoFuncionam.vue').default,CursosLista: require('/opt/buildhome/repo/components/Cursos/Lista.vue').default,CursosOutrosCursos: require('/opt/buildhome/repo/components/Cursos/OutrosCursos.vue').default,CursosAgendarAula: require('/opt/buildhome/repo/components/Cursos/AgendarAula.vue').default,CursosDuvidas: require('/opt/buildhome/repo/components/Cursos/Duvidas.vue').default})
